const baseRoute = 'https://admin-app-server.leada.de';

export const environment = { // tslint:disable-line:typedef
  production: true,
  auth: {
    loginRoute: `${baseRoute}/auth/password`,
    statusRoute: `${baseRoute}/auth/status`,
    logoutRoute: `${baseRoute}/auth/logout`,
  },
  performance: {
    tips: `${baseRoute}/tips/performancesustainment`,
  },
  upcomingSituation: {
    tips: `${baseRoute}/tips/upcomingsituation`,
  },
  users: `${baseRoute}/users`,
  constructs: `${baseRoute}/constructs`,
  undistributedConstructs: `${baseRoute}/constructs/undistributed`,
  dialogs: `${baseRoute}/dialogs`,
  dialogsClone: `${baseRoute}/dialogs/clone`,
  apptexts: `${baseRoute}/apptexts`,
  questions: `${baseRoute}/questions`,
  badges: `${baseRoute}/badges`,
  contents: `${baseRoute}/contents`,
  userImport: `${baseRoute}/users/import`,
  voucherGen: `${baseRoute}/vouchers`,
  voucherValid: `${baseRoute}/vouchers/valid`,
  voucherInvalidate: `${baseRoute}/vouchers/invalidate`,
  domains: `${baseRoute}/vouchers/domains`,
  csvSample: `${baseRoute}/users/import/template`,
  questionChains: `${baseRoute}/questionchains`,
  tiplists: `${baseRoute}/tiplists`,
  theses: `${baseRoute}/theses`,
  cmodules: `${baseRoute}/cmodules`,
  dailyExport: `${baseRoute}/statistics/daily`,
  dialogsExport: `${baseRoute}/statistics/dialogs`,
  questionsExport: `${baseRoute}/statistics/questions`,
  tiplistsExport: `${baseRoute}/statistics/tiplists`,
  contentsExport: `${baseRoute}/statistics/contents`,
  episodesExport: `${baseRoute}/statistics/episodes`,
  targetgroupsExport: `${baseRoute}/statistics/targetgroups`,
  usersExport: `${baseRoute}/statistics/users`,
  targetGroups: {
    groups: `${baseRoute}/groups`,
    categories: `${baseRoute}/categories`,
    managementLevel: `${baseRoute}/management-levels`,
    companies: `${baseRoute}/companies`,
    targetGroups: `${baseRoute}/target-groups`,
    firstOrderTips: `${baseRoute}/questionchains`,
  },
  eventRegistration: {
    codes: `${baseRoute}/event_registration/codes`,
  },
  home: {
    activityAll: `${baseRoute}/statistics/activityAll`,
    answerActivityAll: `${baseRoute}/statistics/answerActivityAll`,
    activityByCompany: `${baseRoute}/statistics/activityByCompany`,
    thesisActivityByCompany: `${baseRoute}/statistics/thesisActivityByCompany`,
    answerActivityByCompany: `${baseRoute}/statistics/answerActivityByCompany`,
    dialogAnswerActivityByCompany: `${baseRoute}/statistics/dialogAnswerActivityByCompany`,
    usersCompany: `${baseRoute}/statistics/usersCompany`,
    usersCreated: `${baseRoute}/statistics/usersCreated`,
    usersFirstUsed: `${baseRoute}/statistics/usersFirstUsed`,
  },
};



// WEBPACK FOOTER //
// /usr/src/app/src/environments/environment.ts